(ns admin.events.learner-reporting
  (:require [kyber.events.utils :refer [add-auth base-uri kyber-event-fx]]
            [kyber.lib.error-reporting :as ke]
            [admin.styles.constants :as sc]
            [applied-science.js-interop :as j]))

(def ^:private learner-mocks
  {"abc-123" {:first-name "Chris"
              :last-name "Smith"
              :started-on "2020-08-20T17:48:43.809Z"
              :active-state "active"
              :overall-readiness 7.4
              :mindset "high"
              :los {:emrs
                    {:readiness 7.3
                     :status "pass"
                     :messages []}

                    :protocol-knowledge
                    {:readiness 8.4
                     :status "pass"
                     :messages []}

                    :scientific-misconduct
                    {:readiness 7.4
                     :status "pass"
                     :messages []}}
              :post-test-question-statuses
              ["pass"
               "pass"
               "pass"
               "pass"
               "pass"]
              :post-test-learner-answers
              [{:pre-test {:answered-correctly true
                           :letter "B"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 1
                            :first-attempt {:answered-correctly true
                                            :letter "B"
                                            :learner-confidence "sure"}}}
               {:post-test {:total-attempts 1
                            :first-attempt {:answered-correctly true
                                            :letter "B"
                                            :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly true
                           :letter "A"
                           :learner-confidence "unsure"}
                :post-test {:total-attempts 1
                            :first-attempt {:answered-correctly true
                                            :letter "C"
                                            :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly true
                           :letter ["A" "B" "C" "D" "E"]
                           :learner-confidence "sure"}
                :post-test {:total-attempts 1
                            :first-attempt {:answered-correctly true
                                            :letter ["A" "B" "C" "D" "E"]
                                            :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly true
                           :letter "D"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 1
                            :first-attempt {:answered-correctly true
                                            :letter "D"
                                            :learner-confidence "sure"}}}]}
   "def-456" {:first-name "Alex"
              :last-name "Drinkwater"
              :started-on "2020-08-16T17:48:43.809Z"
              :active-state "active"
              :overall-readiness 6.2
              :mindset "medium"
              :los {:emrs
                    {:readiness 5.6
                     :status "fail"
                     :messages [{:value "1 question was answered incorrectly"
                                 :status "warning"}]}

                    :protocol-knowledge
                    {:readiness 6.5
                     :status "pass"
                     :messages []}

                    :scientific-misconduct
                    {:readiness 6.3
                     :status "pass"
                     :messages []}}
              :post-test-question-statuses
              ["pass"
               "pass"
               "pass"
               "fail"
               "pass"]
              :post-test-learner-answers
              [{:pre-test {:answered-correctly true
                           :letter "B"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 3
                            :first-attempt {:answered-correctly true
                                            :letter "B"
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly true
                                           :letter "B"
                                           :learner-confidence "sure"}}}
               {:post-test {:total-attempts 3
                            :first-attempt {:answered-correctly true
                                            :letter "B"
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly true
                                           :letter "B"
                                           :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly false
                           :letter "A"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 3
                            :first-attempt {:answered-correctly true
                                            :letter "C"
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly true
                                           :letter "C"
                                           :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly false
                           :letter ["A" "C" "E"]
                           :learner-confidence "unsure"}
                :post-test {:total-attempts 3
                            :first-attempt {:answered-correctly false
                                            :letter ["A" "B" "C" "E"]
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly false
                                           :letter ["A" "B" "C" "D"]
                                           :learner-confidence "guess"}}}
               {:pre-test {:answered-correctly true
                           :letter "D"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 3
                            :first-attempt {:answered-correctly true
                                            :letter "D"
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly true
                                           :letter "D"
                                           :learner-confidence "sure"}}}]}
   "jkl-123" {:first-name "Sam"
              :last-name "Emery"
              :started-on "2020-08-24T17:48:43.809Z"
              :active-state "active"
              :overall-readiness 4.1
              :mindset "low"
              :los {:emrs
                    {:readiness 4.8
                     :status "fail"
                     :messages [{:value "1 question was answered incorrectly"
                                 :status "warning"}]}

                    :protocol-knowledge
                    {:readiness 3.8
                     :status "critical"
                     :messages [{:value "1 KEY question was answered incorrectly"
                                 :status "error"}
                                {:value "2 KEY questions were guessed"
                                 :status "error"}]}

                    :scientific-misconduct
                    {:readiness 4.0
                     :status "fail"
                     :messages [{:value "2 questions were answered incorrectly"
                                 :status "warning"}]}}
              :post-test-question-statuses
              ["guessed"
               "guessed"
               "pass"
               "pass"
               "fail"]
              :post-test-learner-answers
              [{:pre-test {:answered-correctly false
                           :letter "A"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 5
                            :first-attempt {:answered-correctly true
                                            :letter "B"
                                            :learner-confidence "guess"}

                            :last-attempt {:answered-correctly true
                                           :letter "B"
                                           :learner-confidence "sure"}}}
               {:post-test {:total-attempts 5
                            :first-attempt {:answered-correctly true
                                            :letter "B"
                                            :learner-confidence "guess"}

                            :last-attempt {:answered-correctly true
                                           :letter "B"
                                           :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly true
                           :letter "C"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 5
                            :first-attempt {:answered-correctly true
                                            :letter "C"
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly true
                                           :letter "C"
                                           :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly true
                           :letter ["A" "B" "C" "D" "E"]
                           :learner-confidence "unsure"}
                :post-test {:total-attempts 5
                            :first-attempt {:answered-correctly true
                                            :letter ["A" "B" "C" "D" "E"]
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly true
                                           :letter ["A" "B" "C" "D" "E"]
                                           :learner-confidence "sure"}}}
               {:pre-test {:answered-correctly true
                           :letter "B"
                           :learner-confidence "sure"}
                :post-test {:total-attempts 5
                            :first-attempt {:answered-correctly false
                                            :letter "C"
                                            :learner-confidence "sure"}

                            :last-attempt {:answered-correctly false
                                           :letter "C"
                                           :learner-confidence "sure"}}}]}
   "mno-456" {:first-name "Jamie"
              :last-name "Jenkins"
              :started-on "2020-08-26T17:48:43.809Z"
              :active-state "inactive"}})

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; get-post-test
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(def post-test-mock
  [{:title "A Site Monitor is monitoring a study where a known adverse drug
            reaction is QTC prolongation. The protocol states QTC prolongation
            should be reported as an SAE if a triplicate ECG shows an average
            QTC of >500ms, with a confirmatory triplicate ECG within 2 hours
            showing an average QTC of >500ms. The protocol also states that,
            if an avarage of any QTC prolongation triplicate average that does
            not meet the criteria for an SAE but exceeds 450ms, it should be
            reported as an adverse event. The CRA is onsite monitoring and sees
            that a subject had a triplicate ECG at 10:00 with QTC results of
            494, 511, and 498. The next triplicate ECG was performed at 13:00.
            The QTC results were 515, 465, and 499. What documentation would the
            Site Monitor expect to see on site?"
    :type "single-answer"
    :learning-objective "Protocol Knowledge"
    :key-question true
    :graded true
    :status "pass"
    :choices [{:choice-body "Site staff should have reported the event to the
                             Safety Group as an SAE within 24 hours of the
                             event"
               :letter "A"
               :percent-chosen 39
               :uuid "abc123"}
              {:choice-body "Site staff should have reported an AE and a
                             deviation for an out of window 2 hour confirmatory
                             ECG"
               :uuid "def456"
               :letter "B"
               :percent-chosen 51}
              {:choice-body "Site staff should have reported the event as a
                             serious adverse event for the first triplicate
                             ECG and register an AE for the second triplicate
                             ECG"
               :uuid "cool987"
               :letter "C"
               :percent-chosen 3}
              {:choice-body "Site staff should have performed a third ECG
                             triplicate"
               :uuid "cool987"
               :letter "D"
               :percent-chosen 7}]
    :correct-answer "B"
    :educator-feedback "<p>Following the Protocol requirements, QTC prolongation
                        should be reported as an SAE in case  triplicate ECG
                        shows an average QTC of >500ms, with a confirmatory
                        triplicate ECG within 2 hours showing an average QTC of
                        >500ms. At first ECG an avarage QTC was 501ms which
                        meets SAE criteria, however at a confirmatory triplicate
                        ECG an average QTC was 493ms. Thus SAE was not
                        confirmed, but an AE should be reported as an avarage
                        of any QTC prolongation triplicate average exceeds
                        450ms. Also the site should complete a deviation as the
                        second triplicate ECG was done 3 hours after the first
                        one though protocol requires a confirmatory triplicate
                        ECG within 2 hours. </p>"}

   {:title "Inclusion criteria stipulates that a potential subject’s TSH
            [Thyroid stimulating hormone] must be <3.0uIU/mL. The Principal
            Investigator (PI) decides to enroll a subject with a TSH of
            3.3uIU/mL because the upper range is varied by many factors and
            the difference is not considered clinically significant. What
            action should the Site Monitor take?"
    :type "single-answer"
    :learning-objective "Protocol Knowledge"
    :key-question true
    :graded true
    :status "fail"
    :choices [{:choice-body "Instruct the site to notify the subject and
                             discontinue IP immediately"
               :letter "A"
               :percent-chosen 20
               :uuid "abc123"}
              {:choice-body "Confirm and Document a Protocol Deviation in the
                             System of Record"
               :uuid "def456"
               :letter "B"
               :percent-chosen 52}
              {:choice-body "Verify that the site has followed their standard
                             of care procedures"
               :uuid "cool987"
               :letter "C"
               :percent-chosen 7}
              {:choice-body "Verify the PI has documented his assessment of
                             clinical significance"
               :uuid "cool987"
               :letter "D"
               :percent-chosen 21}]
    :correct-answer "B"
    :educator-feedback "As per Company X-QMS-01401 SOP WI Interim Monitoring Visit
                        (IMV) if an ineligible subject is enrolled, the Site
                        Monitor immediately escalates to the CTM per PMP/CMP,
                        documents and enters the protocol deviation into the
                        CTMS as per the Company X-QMS-00713 SOP Protocol Deviation
                        Management, the CMP, Medical Monitoring Plan and
                        Protocol Deviation guidance documnet. Also the Site
                        Monitor should notifies the Medical Monitor, if
                        applicable, and instructs the site staff to notify
                        the EC as appropriate."}

   {:title "When potential misconduct is suspected at a site, what action
            should the Site Monitor take?"
    :type "single-answer"
    :learning-objective "Scientific Misconduct"
    :key-question true
    :graded true
    :status "fail"
    :choices [{:choice-body "Notify the sponsor immediately"
               :letter "A"
               :percent-chosen 63
               :uuid "abc123"}
              {:choice-body "Document your findings in the trip report and
                             create an issue in CTMS"
               :uuid "def456"
               :letter "B"
               :percent-chosen 11}
              {:choice-body "Notify QA within one business day"
               :uuid "cool987"
               :letter "C"
               :percent-chosen 24}
              {:choice-body "Place the site on an immediate enrollment hold"
               :uuid "cool987"
               :letter "D"
               :percent-chosen 2}]
    :correct-answer "C"}

   {:title "A Site Monitor must request to review ALL medical records, paper and
            electronic, to confirm that all trial related procedures have been
            conducted and that there were no additional observations noted for
            the subject between visits. Select all applicable records required
            to be requested:"
    :type "multiple-answer"
    :learning-objective "Electronic Medical Records"
    :key-question false
    :graded true
    :status "fail"
    :choices [{:choice-body "Review of AE logs including progress notes"
               :letter "A"
               :uuid "abc123"}
              {:choice-body "Diaries"
               :uuid "def456"
               :letter "B"}
              {:choice-body "Lab Reports"
               :uuid "cool987"
               :letter "C"}
              {:choice-body "Certified copies of the electronical medical
                             record"
               :uuid "cool987"
               :letter "D"}
              {:choice-body "Clinic notes for an unscheduled non study specific
                             visit"
               :uuid "cool987"
               :letter "E"}]
    :correct-answer ["A" "B" "C" "D" "E"]
    :percent-correct 43
    :educator-feedback "<p>Explanation: Following ICH GCP section 5.18.4 a Site
                        Monitor should ensure that the trial is conducted and
                        documented properly by verifying that source documents
                        and other trial rexords are acuaret, complete, kept
                        up-to-date and maintained, and berifying that the
                        invesigator provides all the required reports,
                        notifications, applications, submissions, and that
                        these documnrs are accurate, complete, timeply, legible,
                        dated, and identify the trial (Ref: 5.18.4 i,j)</p>"}
   {:title "According to Company X's process regarding Protocol Deviations, which of
            the following is the Site Monitor's responsibility?"
    :type "single-answer"
    :learning-objective "Source Document Review and Source Data Verification"
    :key-question true
    :graded true
    :status "pass"
    :choices [{:choice-body "Coordinate deviation reviews with the Company X study team"
               :letter "A"
               :percent-chosen 39
               :uuid "abc123"}
              {:choice-body "Develop and distribute criteria for protocol deviations"
               :uuid "def456"
               :letter "B"
               :percent-chosen 51}
              {:choice-body "Request project specific deviation codes"
               :uuid "cool987"
               :letter "C"
               :percent-chosen 3}
              {:choice-body "Identify deviations during a monitoring visit"
               :uuid "cool987"
               :letter "D"
               :percent-chosen 7}]
    :correct-answer "D"}])

(when ^boolean js/goog.DEBUG
  (def event-doc-get-post-test-success
    {:description "post-test analysis success"
     :changelog
     [{:date "28AUG20"
       :event-version 0
       :data {}}]}))

(defn get-post-test-success
  [{:keys [db]} [event-name
                 {:keys [learner-uuid activity-uuid]}
                 response]]
  {:db (assoc-in db [:learner-report
                     activity-uuid
                     learner-uuid
                     :post-test
                     :data]
                 response)
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0
                                            :activity-uuid activity-uuid
                                            :learner-uuid learner-uuid}]]})

(kyber-event-fx :learner-reporting/get-post-test-success get-post-test-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-post-test-failure
    {:description "post-test analysis failure"
     :changelog
     [{:date "28AUG20"
       :event-version 0
       :data {}}]}))

(defn get-post-test-failure
  [{:keys [db]} [event-name
                 {:keys [learner-uuid activity-uuid]}
                 err]]
  {:db (assoc-in db [:learner-report
                     activity-uuid
                     learner-uuid
                     :post-test
                     :error]
                 err)
   :dispatch-n [[:report-error (ke/->failed-request-error event-name)]
                [:analytics/check-failed-request err]
                [:analytics/save-datapoint {:event event-name
                                            :event-version 0
                                            :activity-uuid activity-uuid
                                            :learner-uuid learner-uuid}]]})

(kyber-event-fx :learner-reporting/get-post-test-failure get-post-test-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-post-test
    {:description "post-test analysis request"
     :changelog
     [{:date "28AUG20"
       :event-version 0
       :data {}}]}))

(defn get-post-test
  [{:keys [db]} [event-name {:keys [learner-uuid activity-uuid] :as params}]]
  {:db (update-in db [:learner-report
                      activity-uuid
                      learner-uuid]
                  dissoc
                  :post-test)
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0
                                            :activity-uuid activity-uuid
                                            :learner-uuid learner-uuid}]]
   :request-mock
   {:name event-name
    :method :get
    :uri (base-uri db (str " "))
    :response-format :json
    :headers (add-auth db)
    :on-success [:learner-reporting/get-post-test-success params]
    :on-failure [:learner-reporting/get-post-test-failure params]
    :mock {:data (let [{:keys [post-test-learner-answers
                               post-test-question-statuses]}
                       (get learner-mocks learner-uuid)]
                   (mapv
                    (fn [post-test-mock learner-answers question-status]
                      (-> post-test-mock
                          (assoc :learner-answers learner-answers)
                          (assoc :status question-status)))
                    post-test-mock
                    post-test-learner-answers
                    post-test-question-statuses))
          ;  :error :ugh
           :time 1000}}})

(kyber-event-fx :learner-reporting/get-post-test get-post-test)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; get-moment-questions
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(def moment-question-mock
  [{:title "A Site Monitor is monitoring a study where a known adverse drug
            reaction is QTC prolongation. The protocol states QTC prolongation
            should be reported as an SAE if a triplicate ECG shows an average
            QTC of >500ms, with a confirmatory triplicate ECG within 2 hours
            showing an average QTC of >500ms. The protocol also states that,
            if an avarage of any QTC prolongation triplicate average that does
            not meet the criteria for an SAE but exceeds 450ms, it should be
            reported as an adverse event. The CRA is onsite monitoring and sees
            that a subject had a triplicate ECG at 10:00 with QTC results of
            494, 511, and 498. The next triplicate ECG was performed at 13:00.
            The QTC results were 515, 465, and 499. What documentation would the
            Site Monitor expect to see on site?"

    :type "single-answer"
    :learning-objective "Protocol Knowledge"
    :moment-question true
    :key-question true
    :graded true
    :status "pass"
    :choices [{:choice-body "Site staff should have reported the event to the
                             Safety Group as an SAE within 24 hours of the
                             event"
               :letter "A"
               :percent-chosen 39
               :uuid "abc123"}
              {:choice-body "Site staff should have reported an AE and a
                             deviation for an out of window 2 hour confirmatory
                             ECG"
               :uuid "def456"
               :letter "B"
               :percent-chosen 51}
              {:choice-body "Site staff should have reported the event as a
                             serious adverse event for the first triplicate
                             ECG and register an AE for the second triplicate
                             ECG"
               :uuid "cool987"
               :letter "C"
               :percent-chosen 3}
              {:choice-body "Site staff should have performed a third ECG
                             triplicate"
               :uuid "cool987"
               :letter "D"
               :percent-chosen 7}]
    :correct-answer "B"
    :learner-answers {:answered-correctly true
                      :letter "B"}
    :educator-feedback "<p>Following the Protocol requirements, QTC prolongation
                        should be reported as an SAE in case  triplicate ECG
                        shows an average QTC of >500ms, with a confirmatory
                        triplicate ECG within 2 hours showing an average QTC of
                        >500ms. At first ECG an avarage QTC was 501ms which"}

   {:title  "A Site Monitor must request to review ALL medical records, paper and
            electronic, to confirm that all trial related procedures have been
            conducted and that there were no additional observations noted for
            the subject between visits. Select all applicable records required
            to be requested:"
    :type "multiple-answer"
    :moment-question true
    :learning-objective "Electronic Medical Records"
    :key-question false
    :graded true
    :status "fail"
    :choices [{:choice-body "Review of AE logs including progress notes"
               :letter "A"
               :uuid "abc123"}
              {:choice-body "Diaries"
               :uuid "def456"
               :letter "B"}
              {:choice-body "Lab Reports"
               :uuid "cool987"
               :letter "C"}
              {:choice-body "Certified copies of the electronical medical
                             record"
               :uuid "cool987"
               :letter "D"}
              {:choice-body "Clinic notes for an unscheduled non study specific
                             visit"
               :uuid "cool987"
               :letter "E"}]
    :correct-answer ["A" "B" "C" "D" "E"]
    :percent-correct 43
    :learner-answers {:answered-correctly false
                      :letter ["A" "C" "E"]}
    :educator-feedback "<p>Explanation: Following ICH GCP section 5.18.4 a Site
                        Monitor should ensure that the trial is conducted and
                        documented properly by verifying that source documents
                        and other trial rexords are acuaret, complete, kept
                        up-to-date and maintained, and berifying that the
                        invesigator provides all the required reports,
                        notifications, applications, submissions, and that
                        these documnrs are accurate, complete, timeply, legible,
                        dated, and identify the trial (Ref: 5.18.4 i,j)</p>"}])

(when ^boolean js/goog.DEBUG
  (def event-doc-get-moment-question-success
    {:description "moment-question analysis success"
     :changelog
     [{:date "22SEP20"
       :event-version 0
       :data {}}]}))

(defn get-moment-question-success
  [{:keys [db]} [event-name
                 {:keys [learner-uuid activity-uuid]}
                 response]]
  {:db (assoc-in db [:learner-report
                     activity-uuid
                     learner-uuid
                     :moment-question
                     :data]
                 response)
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0
                                            :activity-uuid activity-uuid
                                            :learner-uuid learner-uuid}]]})

(kyber-event-fx :learner-reporting/get-moment-question-success
                get-moment-question-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-moment-question-failure
    {:description "moment-question analysis failure"
     :changelog
     [{:date "22SEP20"
       :event-version 0
       :data {}}]}))

(defn get-moment-question-failure
  [{:keys [db]} [event-name
                 {:keys [learner-uuid activity-uuid]}
                 err]]
  {:db (assoc-in db [:learner-report
                     activity-uuid
                     learner-uuid
                     :moment-question
                     :error]
                 err)
   :dispatch-n [[:report-error (ke/->failed-request-error event-name)]
                [:analytics/check-failed-request err]
                [:analytics/save-datapoint {:event event-name
                                            :event-version 0
                                            :activity-uuid activity-uuid
                                            :learner-uuid learner-uuid}]]})

(kyber-event-fx :learner-reporting/get-moment-question-failure
                get-moment-question-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-get-moment-question
    {:description "moment-question analysis request"
     :changelog
     [{:date "22SEP20"
       :event-version 0
       :data {}}]}))

(defn get-moment-question
  [{:keys [db]} [event-name {:keys [learner-uuid activity-uuid] :as params}]]
  {:db (update-in db [:learner-report activity-uuid learner-uuid]
                  dissoc
                  :moment-question)
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0
                                            :activity-uuid activity-uuid
                                            :learner-uuid learner-uuid}]]
   :request-mock
   {:name event-name
    :method :get
    :uri (base-uri db (str " "))
    :response-format :json
    :headers (add-auth db)
    :on-success [:learner-reporting/get-moment-question-success params]
    :on-failure [:learner-reporting/get-moment-question-failure params]
    :mock {:data moment-question-mock
          ;  :error :ugh
           :time 1000}}})

(kyber-event-fx :learner-reporting/get-moment-question get-moment-question)

;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Toggle sidebar
;; ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn create-resize-event []
  (new js/Event "resize")) 

(defn trigger-window-resize []
  (j/call js/window :setTimeout #(j/call js/window :dispatchEvent (create-resize-event)) sc/learner-dashboard-sidebar-transition-time))

(when ^boolean js/goog.DEBUG
  (def event-doc-name
    {:description "toggle sidebar"
     :changelog
     [{:date "06OCT20"
       :event-version 0
       :data {}}]}))

(defn toggle-sidebar
  [{:keys [db]} [event-name]]
  {:db (update-in db [:learner-reporting :sidebar-open?] not)
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :invoke trigger-window-resize})

(kyber-event-fx :learner-reporting/toggle-sidebar toggle-sidebar)